import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const CLUBS_POST_REQUEST = 'POST_CLUBS_REQUEST';
export const CLUBS_POST_FAILURE = 'POST_CLUBS_FAILURE';
export const CLUBS_POST_SUCCESS = 'POST_CLUBS_SUCCESS';

export const postClub = data => {
    return function(dispatch) {
        dispatch(postRequest());
        return axios(apiRequestOptions(apiPath.CLUBS.POST, data))
            .then(transformHttpResponse)
            .then(response => dispatch(postSuccess(response.data)))
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(postFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const postRequest = () => {
    return {type: CLUBS_POST_REQUEST}
};

const postFailure = error => {
    return {type: CLUBS_POST_FAILURE, error}
};

const postSuccess = club => {
    return {type: CLUBS_POST_SUCCESS, club}
};